import { useQuery } from '@tanstack/react-query';

import { contactApi } from '@/entities/contacts';
import { isRetryableApiError } from '@/shared/api';

export const contactsPageQueryKeys = {
  all: ['contacts'] as const,
  page: () => [...contactsPageQueryKeys.all, 'contacts'] as const,
};

export const useContactsData = () => {
  return useQuery({
    queryKey: contactsPageQueryKeys.page(),
    queryFn: () => contactApi(),
    placeholderData: (previousData) => previousData,
    retry: (failureCount, error) =>
      failureCount < 2 && isRetryableApiError(error),
  });
};
